import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Warehouse } from 'src/app/assabil-kernel/models/entities/master-data/warehouse-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'warehouse-lov',
    templateUrl: './warehouse-lov.component.html',
    styleUrls: ['./warehouse-lov.component.scss']
})


export class WarehouseLovComponent extends GenericLovComponent {

    code         : string; 
    name         : string; 

    warehouses            : Warehouse[] = [];

    columns = [
        {  prop: 'warehouseCode',   name: 'Code'},
        {  prop: 'name',             name: 'Nom'},
    ]


//----------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<WarehouseLovComponent>,
    protected controlTablesService  : ControlTablesService) {
        super();
        this.entityName = "warehouse";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.warehouses = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : Warehouse){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
